import UserProfileDropdown from './UserProfileDropdown';

const HeaderRight = ({ setFetchingUserData }) => (
  <div className="navbar-right">
    <UserProfileDropdown setFetchingUserData={setFetchingUserData} />
  </div>
);

export default HeaderRight;
